export default __webpack_public_path__ + "static/media/vehicle_pickup.36dff475.svg";